// extracted by mini-css-extract-plugin
export default {"nav-link":"EY4QI","active":"uTKXr"};